module.exports = __webpack_public_path__ + "static/media/talisis-responsive.081cbc3b.svg";